module.exports = __webpack_public_path__ + "img/meeting-empty.bbe166ff.png";